module.exports = __webpack_public_path__ + "assets/ff05586f94b80dab90de7983d391c42e.mp4";